// ============================================
// CONSTANTS (separate file: constants/formConstants.js)
// ============================================
export const FIELD_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
  PASSWORD: 'password',
  NUMBER: 'number',
  TEXTAREA: 'textarea',
  SELECT: 'select',
  MULTI_SELECT: 'multiselect',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  DATE: 'date',
  TIME: 'time',
  DATETIME: 'datetime-local',
  FILE: 'file',
  RANGE: 'range',
  COLOR: 'color',
  ARRAY: 'array',
  GROUP: 'group',
  CUSTOM: 'custom',
  PHONE: 'tel',
  URL: 'url',
  SWITCH: 'switch',
  AUTOCOMPLETE: 'autocomplete',
  RATING: 'rating',
  OTP: 'otp',
  SELECT_SEARCH: 'selectSearch',
  SEARCH_SELECT: 'searchSelect',
  MULTI_SELECT_SEARCH: 'multiSelectSearch',
  MULTI_SEARCH_SELECT: 'multiSearchSelect'
};

export const LAYOUT_TYPES = {
  SINGLE: 'single',
  GRID: 'grid',
  FLEX: 'flex'
};

export const COLUMN_SPANS = {
  FULL: 'full',
  HALF: 'half',
  THIRD: 'third',
  TWO_THIRDS: 'two-thirds',
  QUARTER: 'quarter',
  THREE_QUARTERS: 'three-quarters'
};

export const VALIDATION_PRESETS = {
  email: {
    required: 'Email is required',
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'Invalid email address'
    }
  },
  phone: {
    required: 'Phone number is required',
    pattern: {
      value: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
      message: 'Invalid phone number'
    }
  },
  url: {
    required: 'URL is required',
    pattern: {
      value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i,
      message: 'Invalid URL'
    }
  },
  alphanumeric: {
    pattern: {
      value: /^[a-zA-Z0-9]+$/,
      message: 'Only letters and numbers allowed'
    }
  }
};